import React, { useState } from 'react';
import api from '../api';
import Card, { CardBody, CardFooter } from './ui/Card';
import Input from './ui/Input';
import Button from './ui/Button';
import './Auth.css';

/**
 * @param {string|null} notice out-of-band message to show above the form, e.g.
 *   "Session expired." after the API client dropped an invalid token.
 */
function Login({ onLoginSuccess, onSwitchToRegister, notice = null }) {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await api.post('/login/', formData);
            localStorage.setItem('authToken', response.data.token);
            localStorage.setItem('username', response.data.username);
            localStorage.setItem('userId', response.data.user_id);
            onLoginSuccess(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <Card variant="glass" padding="none" className="auth-card animate-scale-in">
                <CardBody>
                    <div className="auth-header">
                        <div className="auth-icon">🔐</div>
                        <h2>Welcome Back</h2>
                        <p className="auth-subtitle">Sign in to continue your adventure</p>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-form">
                        {notice && !error && (
                            <div className="alert alert-warning" role="status">
                                <span className="alert-icon">⏳</span>
                                <span>{notice}</span>
                            </div>
                        )}

                        {error && (
                            <div className="alert alert-error">
                                <span className="alert-icon">⚠️</span>
                                <span>{error}</span>
                            </div>
                        )}

                        <Input
                            label="Username"
                            type="text"
                            leftIcon="👤"
                            value={formData.username}
                            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                            required
                            autoFocus
                            placeholder="Enter your username"
                        />

                        <Input
                            label="Password"
                            type="password"
                            leftIcon="🔒"
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            required
                            placeholder="Enter your password"
                        />

                        <Button
                            type="submit"
                            variant="primary"
                            size="lg"
                            fullWidth
                            loading={loading}
                            className="auth-submit-btn"
                        >
                            Sign In
                        </Button>
                    </form>
                </CardBody>

                {onSwitchToRegister && (
                    <CardFooter>
                        <div className="auth-footer">
                            <span>Don't have an account?</span>
                            <Button
                                variant="link"
                                onClick={onSwitchToRegister}
                            >
                                Create Account
                            </Button>
                        </div>
                    </CardFooter>
                )}
            </Card>
        </div>
    );
}

export default Login;
